import axios from "../../../axios";
import { paramsObjToGraphQLParams } from "@/utils/index.js";

export default {
  fetch(queryData) {
    return axios.post("", {
      query: `
        query {
          news ${paramsObjToGraphQLParams(queryData)} {
            order_by,
            pagination_page,
            pagination_limit,
            total_pages,
            items {
              id,
              headline,
              slug,
              subtitle,
              content,
              thumbnail,
              call,
              activated,
              is_highlighted,
              is_main,
              schedule_publish_at,
              category {
                id,
                name
              },
              author {
                id,
                name,
                email,
                role {
                  id,
                  name
                }
              },
              created_at,
              updated_at,
              expanded_qty
            }
          }
        }
      `,
    });
  },
  add(news) {    
    return axios.post('', {
      query: `
        mutation {
          createNews(
            headline: "${news.headline.replace(/"/g, '\\"')}",
            subtitle: "${news.subtitle.replace(/"/g, '\\"')}",
            content: "${news.content}",
            category_id: ${news.category.id},
            thumbnail: "${news.thumbnail}",
            call: "${news.call.replace(/"/g, '\\"')}",
            hidden_content: "${news.hidden_content}",
            schedule_publish_at: ${news.schedule_publish_at !== null ? `"${news.schedule_publish_at}"` : null}
          ) {
            id,
            headline,
            slug,
            subtitle,
            content,
            thumbnail,
            call,
            activated,
            is_highlighted,
            is_main,
            schedule_publish_at,
            category {
              id,
              name
            },
            author {
              id,
              name,
              email,
              role {
                id,
                name
              }
            },
            created_at,
            updated_at
          }
        }
      `,
    });
  },
  update(news) {
    return axios.post("", {
      query: `
        mutation {
          updateNews(
            id: ${news.id},
            ${news.headline !== undefined ? `headline: "${news.headline.replace(/"/g, '\\"')}",` : ''}
            ${news.subtitle !== undefined ? `subtitle: "${news.subtitle.replace(/"/g, '\\"')}",` : ''}
            ${news.content !== undefined ? `content: "${news.content}",` : ''}
            ${news.category !== undefined ? `category_id: ${news.category.id},` : ''}
            ${news.activated !== undefined ? `activated: ${news.activated},` : ''}
            ${news.thumbnail !== undefined ? `thumbnail: "${news.thumbnail}",` : ''}
            ${news.call !== undefined ? `call: "${news.call.replace(/"/g, '\\"')}",` : ''}
            ${news.hidden_content !== undefined ? `hidden_content: "${news.hidden_content}",` : ''}
            ${news.is_highlighted !== undefined ? `is_highlighted: ${news.is_highlighted},` : ''}
            ${news.is_main !== undefined ? `is_main: ${news.is_main},` : ''}
            ${news.schedule_publish_at !== undefined ? (
              `schedule_publish_at: ${news.schedule_publish_at !== null ? `"${news.schedule_publish_at}"` : null}`
            ) : ''}
          ) {
            id,
            headline,
            slug,
            subtitle,
            content,
            thumbnail,
            call,
            activated,
            is_highlighted,
            is_main,
            schedule_publish_at,
            category {
              id,
              name
            },
            author {
              id,
              name,
              email,
              role {
                id,
                name
              }
            },
            created_at,
            updated_at
          }
        }
      `,
    });
  },
  delete(newsId) {
    return axios.post("", {
      query: `
        mutation {
          deleteNews (
            id: ${newsId}
          )
        }
      `,
    });
  },
  infos(newsId) {
    return axios.post("", {
      query: `
        query {
          newsInfos (
            id: ${newsId}
          ) {
            id,
            headline,
            slug,
            subtitle,
            content,
            hidden_content,
            thumbnail,
            call,
            activated,
            is_highlighted,
            is_main,
            schedule_publish_at,
            category {
              id,
              name
            },
            author {
              id,
              name,
              email,
              role {
                id,
                name
              }
            },
            created_at,
            updated_at,
            expanded_qty
          }
        }
      `,
    });
  },
};
